module.exports = __webpack_public_path__ + "img/icona-10gukeliebiaobeifen.553bc9c5.png";